import { render } from "./TasksListShowModal.vue?vue&type=template&id=ba47e430"
import script from "./TasksListShowModal.vue?vue&type=script&lang=js"
export * from "./TasksListShowModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__